import { useState, useCallback, useRef, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  Grid,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Toast from "helper/toast";
import SalesCard from "components/shared/SalesCard";
import TableCM from "components/shared/Table";
import DatePickerCM from "components/shared/DatePicker";
import Icon from "react-multi-date-picker/components/icon";
import { convertDate, DATE_FORMATS } from "helper/date";
import DrawerCM from "components/shared/Drawer";
import GenarateHeadCell from "helper/generate-head-cell";
import PaginationCM from "components/shared/Pagination";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import ClearIcon from "@mui/icons-material/Clear";
import {
  getOrdersStatsRequest,
  getFilterCategoryRequest,
  getAllDesignRequest,
} from "api/requests";
import {
  StyledStack,
  StyledTitle,
  ButtonContainer,
  StyledMenuItem,
  StyledPaper,
  Styleddetails,
} from "./Stats.style";
import { PAGINATION_LIMIT } from "constants";
import CheckIcon from "@mui/icons-material/Check";
import useFilter from "hooks/use-filter";
import spliter from "helper/digit-spliter";

const headCells = GenarateHeadCell("orders");
let initialPage = 1;

let types = [
  { id: 1, name: "مبلمان" },
  { id: 2, name: "اکسسوری" },
];

let userTypes = [
  { id: 1, name: "user", title: "عادي" },
  { id: 2, name: "colleague", title: "همكار" },
];

export default function OrdersStats() {
  const datePickerRefFrom = useRef();
  const datePickerRefTo = useRef();
  const { request, loading, setLoading } = useHttp();
  const {
    register,
    formState: { errors },
  } = useForm();
  const [orders, setOrders] = useState({ data: [] });
  const [total_price, setTotal_price] = useState("");
  const [total_quantity, setTotal_quantity] = useState("");
  const [category, setCategory] = useState({ data: [], count: 0 });
  const [design, setDesign] = useState({ data: [], count: 0 });
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedUserType, setSelectedUserType] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedDesign, setSelectedDesign] = useState("");
  const [PaymentStatus, setPaymentStatus] = useState("successful");
  const [searchValue, setSearchValue] = useState("");
  const [dateValueFrom, setDateValueFrom] = useState("");
  const [dateValueTo, setDateValueTo] = useState("");

  const [page, setPage] = useState(initialPage);

  // const handelSearch = (e) => getOrders(e);

  const handleDateChangeFrom = (value) => {
    const date = convertDate({
      time: new Date(value),
      format: DATE_FORMATS.faDateTime,
    });
    setDateValueFrom(date);
  };

  const handleDateChangeTo = (value) => {
    const date = convertDate({
      time: new Date(value),
      format: DATE_FORMATS.faDateTime,
    });
    setDateValueTo(date);
  };

  const getDesign = useCallback(async () => {
    const res = await request({
      url: getAllDesignRequest,
      values: {
        skip: 0,
        limit: 1000,
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      title: items.title,
      category_id: items.category_id,
    }));

    setDesign({ data: transformedData, count: res.count });
  }, [page, request]);

  useEffect(() => {
    getDesign();
  }, [page, getDesign]);

  const getCategory = useCallback(async () => {
    const res = await request({
      url: getFilterCategoryRequest,
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      title: items.title,
      type: items.type,
    }));

    setCategory({ data: transformedData, count: res.count });
  }, [request]);
  useEffect(() => {
    getCategory();
  }, [getCategory]);

  const getOrders = async (search) => {
    setLoading(true);

    const orderRes = await request({
      url: getOrdersStatsRequest,
      values: {
        search: searchValue,
        payment_status: "successful",
        user_type: selectedUserType.name,
        category_type: selectedType.name,
        category_id: selectedCategory.name,
        design_id: selectedDesign.name,
        created_at_from: dateValueFrom.enDate,
        created_at_to: dateValueTo.enDate,
      },
      isMulty: true,
    });

    setLoading(false);

    if (orderRes) {
      const transormedOrderData = orderRes.types.map((items) => ({
        type: items.type,
        total_price_Type: items.total_price,
        total_quantity_Type: items.total_quantity,
        categories: items.categories,
        designs: items.categories?.designs,
        products: items.categories?.designs?.products,
      }));
      // let totalAmount = 0;

      setOrders({ data: transormedOrderData });
      setTotal_price(orderRes?.total_price);
      setTotal_quantity(orderRes?.total_quantity);
    }
  };

  const getOrdersWithoutFilter = async (search) => {
    setLoading(true);
    setSelectedUserType("");
    setSelectedDesign("");
    setSelectedType("");
    setSelectedCategory("");
    setPaymentStatus("successful");
    setSearchValue("");
    setDateValueFrom("");
    setDateValueTo("");
    const orderRes = await request({
      url: getOrdersStatsRequest,
      values: {},
      isMulty: true,
    });

    setLoading(false);

    if (orderRes) {
      const transormedOrderData = orderRes.types.map((items) => ({
        type: items.type,
        total_price_Type: items.total_price,
        total_quantity_Type: items.total_quantity,
        categories: items.categories,
        designs: items.categories?.designs,
        products: items.categories?.designs?.products,
      }));
      // let totalAmount = 0;

      setOrders({ data: transormedOrderData });
      setTotal_price(orderRes?.total_price);
      setTotal_quantity(orderRes?.total_quantity);
    }
  };

  useEffect(() => {
    getOrders();
  }, [page]);

  return (
    <DrawerCM title=" آمار سفارشات ">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2} spacing={1}>
          <StyledStack>
            <StyledTitle>فیلتر</StyledTitle>
            <Grid container>
              <Grid item md={4} xs={12} p={1}>
                <FormControl fullWidth size="small">
                  <InputLabel id="select-type">سردسته</InputLabel>
                  <Select
                    labelId="select-type"
                    label="سردسته"
                    value={selectedType?.name}
                    // defaultValue={userData?.type}
                    id="type"
                    {...register("type")}
                    error={Boolean(errors.type)}
                    helpertext={errors.type?.message}
                    onChange={(e) =>
                      setSelectedType({
                        name: e.target.value,
                      })
                    }
                  >
                    {types?.map((item, index) => (
                      <MenuItem
                        key={index}
                        value={item.name}
                        style={{
                          direction: "rtl",
                        }}
                      >
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={4} xs={12} p={1}>
                <FormControl fullWidth size="small">
                  <InputLabel id="select-category">زیردسته</InputLabel>
                  <Select
                    labelId="select-category"
                    label="زیردسته"
                    value={selectedCategory?.name}
                    // defaultValue={userData?.category}
                    id="category"
                    {...register("category")}
                    error={Boolean(errors.category)}
                    helpertext={errors.category?.message}
                    onChange={(e) => {
                      // console.log(selectedCategory);
                      setSelectedCategory({
                        name: e.target.value,
                      });
                    }}
                  >
                    {category.data
                      ?.filter(
                        (item) =>
                          item.type ===
                          types?.find((item) => item.name === selectedType.name)
                            ?.name
                      )
                      .map((item, index) => (
                        <MenuItem
                          key={index}
                          value={item.id}
                          style={{
                            direction: "rtl",
                          }}
                        >
                          {item.title}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={4} xs={12} p={1}>
                <FormControl fullWidth size="small">
                  <InputLabel id="select-design">طرح</InputLabel>
                  <Select
                    labelId="select-design"
                    label="طرح"
                    value={selectedDesign?.name}
                    // defaultValue={userData?.category}
                    id="design_id"
                    {...register("design_id")}
                    error={Boolean(errors.design_id)}
                    helpertext={errors.design_id?.message}
                    onChange={(e) =>
                      setSelectedDesign({
                        name: e.target.value,
                      })
                    }
                  >
                    {design.data?.length > 0 &&
                      design.data
                        ?.filter(
                          (item) =>
                            item.category_id ==
                            category.data?.find(
                              (item) => item.id == selectedCategory.name
                            )?.id
                        )
                        .map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item.id}
                            style={{
                              direction: "rtl",
                            }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                  </Select>
                </FormControl>
              </Grid>
              {/* <Grid item md={4} xs={12} p={1}>
                <FormControl fullWidth size="small">
                  <InputLabel id="select-Status">وضعيت سفارش</InputLabel>
                  <Select
                    labelId="select-Status"
                    label="وضعيت سفارش"
                    value={PaymentStatus?.name}
                    // defaultValue={userData?.type}
                    id="Status"
                    {...register("Status")}
                    error={Boolean(errors.Status)}
                    helpertext={errors.Status?.message}
                    onChange={(e) =>
                      setPaymentStatus({
                        name: e.target.value,
                      })
                    }
                  >
                    {Status?.map((item, index) => (
                      <MenuItem
                        key={index}
                        value={item.name}
                        style={{
                          direction: "rtl",
                        }}
                      >
                        {item.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}
              <Grid item md={4} xs={12} p={1}>
                <TextField
                  id="startDate"
                  label="تاریخ شروع"
                  variant="outlined"
                  size="small"
                  fullWidth
                  readOnly
                  value={dateValueFrom.faDate}
                  onClick={() => datePickerRefFrom.current.openCalendar()}
                ></TextField>
                <DatePickerCM
                  useref={datePickerRefFrom}
                  value={new Date(dateValueFrom.faDate)}
                  onChange={handleDateChangeFrom}
                  render={<Icon size={0} />}
                  type="Date"
                />
              </Grid>
              <Grid item md={4} xs={12} p={1}>
                <TextField
                  id="endDate"
                  label="تاریخ پايان"
                  variant="outlined"
                  size="small"
                  fullWidth
                  readOnly
                  value={dateValueTo.faDate}
                  onClick={() => datePickerRefTo.current.openCalendar()}
                ></TextField>
                <DatePickerCM
                  useref={datePickerRefTo}
                  value={new Date(dateValueTo.faDate)}
                  onChange={handleDateChangeTo}
                  render={<Icon size={0} />}
                  type="Date"
                />
              </Grid>
              <Grid item md={4} xs={12} p={1}>
                <FormControl fullWidth size="small">
                  <InputLabel id="select-type">نوع كاربر</InputLabel>
                  <Select
                    labelId="select-user-type"
                    label="نوع كاربر"
                    value={selectedUserType?.name}
                    // defaultValue={userData?.type}
                    id="userTypes"
                    {...register("userTypes")}
                    error={Boolean(errors.userTypes)}
                    helpertext={errors.userTypes?.message}
                    onChange={(e) =>
                      setSelectedUserType({
                        name: e.target.value,
                      })
                    }
                  >
                    {userTypes?.map((item, index) => (
                      <MenuItem
                        key={index}
                        value={item.name}
                        style={{
                          direction: "rtl",
                        }}
                      >
                        {item.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={12} xs={12} p={1}>
                <TextField
                  label="جست و جو"
                  fullWidth
                  id="outlined-size-small"
                  size="small"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </Grid>
              <ButtonContainer>
                <Button
                  color="error"
                  startIcon={<ClearIcon />}
                  variant="outlined"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={getOrdersWithoutFilter}
                >
                  حذف فیلتر
                </Button>
                <Button
                  color="success"
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={getOrders}
                >
                  فيلتر
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>

          <Grid item xs={12} my={2}>
            {orders.data.map((item, index) => (
              <Styleddetails
                key={index}
                style={{ paddingRight: "0 !important", marginBottom: "10px" }}
              >
                <summary>
                  <div>
                    <div>{item.type}</div>
                    <div>{spliter(item.total_price_Type)}</div>
                    <div>{item.total_quantity_Type}</div>
                  </div>
                </summary>
                <div>
                  {item.categories.map((item, index) => (
                    <Styleddetails key={index}>
                      <summary>
                        <div>
                          <div>{item.category.title}</div>
                          <div>{spliter(item.total_price)}</div>
                          <div>{item.total_quantity}</div>
                        </div>
                      </summary>
                      <div>
                        {item.designs.map((item, index) => (
                          <Styleddetails key={index}>
                            <summary>
                              <div>
                                <div>{item.design.title}</div>
                                <div>{spliter(item.total_price)}</div>
                                <div>{item.total_quantity}</div>
                              </div>
                            </summary>

                            <div>
                              {item.products.map((item, index) => (
                                <StyledPaper key={index}>
                                  <div>
                                    <div>{item.product.title}</div>
                                    <div>{spliter(item.total_price)}</div>
                                    <div>{item.total_quantity}</div>
                                  </div>
                                </StyledPaper>
                              ))}
                            </div>
                          </Styleddetails>
                        ))}
                      </div>
                    </Styleddetails>
                  ))}
                </div>
              </Styleddetails>
            ))}
          </Grid>
          <Grid item xs={12} my={2}>
            {/* {orders.data.map((item, index) => (
              <StyledPaper key={index}>
                <div>
                  <div>سردسته : {item.type}</div>
                  <div>{spliter(item.total_price_Type)}</div>
                  <div>{item.total_quantity_Type}</div>
                </div>
                {item.categories.map((item, index) => (
                  <StyledPaper key={index}>
                    <div>
                      <div>زیردسته : {item.category.title}</div>
                      <div>{spliter(item.total_price)}</div>
                      <div>{item.total_quantity}</div>
                    </div>
                    {item.designs.map((item, index) => (
                      <StyledPaper key={index}>
                        <div>
                          <div>طرح : {item.design.title}</div>
                          <div>{spliter(item.total_price)}</div>
                          <div>{item.total_quantity}</div>
                        </div>
                        {item.products.map((item, index) => (
                          <StyledPaper key={index}>
                            <div>
                              <div>محصول : {item.product.title}</div>
                              <div>{spliter(item.total_price)}</div>
                              <div>{item.total_quantity}</div>
                            </div>
                          </StyledPaper>
                        ))}
                      </StyledPaper>
                    ))}
                  </StyledPaper>
                ))}
              </StyledPaper>
            ))} */}
            <StyledPaper>
              <div>
                <div>مجموع کل</div>
                <div>{spliter(total_price)}</div>
                <div>{total_quantity}</div>
              </div>
            </StyledPaper>
            {/* <TableCM
              title=" آمار سفارشات"
              rows={orders.data}
              headCells={headCells}
              click={(orderId) => navigate("/orders/" + orderId)}
              page={page}
            /> */}
          </Grid>
        </Grid>
      )}
    </DrawerCM>
  );
}
